import React from 'react';
import { Link } from 'react-router-dom';
import logoWhite from '../assets/logo-main-white.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer bg-navy">
      
      {/* MOBILE CSS OVERRIDES FOR FOOTER */}
      <style>
        {`
          @media (max-width: 768px) {
            .footer-main-grid {
              text-align: center;
              gap: 3rem !important;
            }
            .brand-col {
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            .footer-about-text {
              margin: 0 auto 1.5rem auto !important;
            }
            .footer-socials {
              justify-content: center;
            }
            .footer-contact-list li {
              flex-direction: column;
              align-items: center;
              gap: 0.25rem !important;
            }
            .contact-label { margin-bottom: 0.2rem; }
            .footer-bottom-flex {
              flex-direction: column;
              gap: 1.5rem;
              text-align: center;
            }
            .legal-links {
              justify-content: center;
              flex-wrap: wrap;
              gap: 1rem !important;
            }
          }
        `}
      </style>

      <div className="container">
        
        <div className="footer-main-grid">
          
          {/* Column 1: Brand & About */}
          <div className="footer-col brand-col">
            <Link to="/" style={{ display: 'inline-block', marginBottom: '-1rem' }}>
              <img 
                src={logoWhite} 
                alt="Nightmark Protective Services" 
                className="footer-logo" 
                style={{ width: '220px', height: 'auto', maxWidth: '100%' }} 
              />
            </Link>
            <p className="footer-about-text" style={{ marginTop: 0 }}>
              Intelligence-led security solutions tailored to mitigate risk, protect assets and ensure operational continuity across the UK.
            </p>
            <div className="footer-socials">
              <a href="https://www.linkedin.com/company/nightmarkprotectiveservices" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">In</a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-col links-col">
            <h4>Company</h4>
            <ul className="footer-nav-list">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/news">News & Insights</Link></li>
              <li><Link to="/martyns-law">Martyn's Law</Link></li>
              <li><Link to="/contact">Contact Operations</Link></li>
              <li><Link to="/staff-login">Staff Portal</Link></li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div className="footer-col links-col">
            <h4>Operations</h4>
            <ul className="footer-nav-list">
              <li><Link to="/services/corporate-security">Corporate Security</Link></li>
              <li><Link to="/services/concierge">Concierge Services</Link></li>
              <li><Link to="/services/mobile-patrols">Mobile Patrols</Link></li>
              <li><Link to="/services/key-holding">Key Holding & Alarm Response</Link></li>
            </ul>
          </div>

          {/* Column 4: Contact Info */}
          <div className="footer-col contact-col">
            <h4>Headquarters</h4>
            <ul className="footer-contact-list">
              <li>
                <span className="contact-label">A:</span>
                <p>81 Crewe Road, Alsager<br />Stoke On Trent, ST7 2EZ<br />United Kingdom</p>
              </li>
              <li>
                <span className="contact-label">T:</span>
                <a href="tel:08001234567" className="footer-phone"> 01270 446302</a>
              </li>
              <li>
                <span className="contact-label">E:</span>
                <a href="mailto:info@nightmarkprotectiveservices.com" className="lowercase-email">info@nightmarkprotectiveservices.com</a>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Strip */}
        <div className="footer-bottom-strip">
          <div className="footer-bottom-flex">
            <p className="copyright-text">
              &copy; {currentYear} Nightmark Protective Services. Powered by <a href="https://xyrox.co.uk/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-white)', textDecoration: 'none', fontWeight: '600' }}>Xyro X</a>
            </p>
            <div className="legal-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/modern-slavery">Modern Slavery Statement</Link>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;